import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-zinc-500 text-sm" data-testid="auth-loading">
        Authenticating...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-zinc-400" data-testid="forbidden">
        <div className="text-center max-w-md">
          <div className="label-uppercase text-red-500 mb-2">403 — Forbidden</div>
          <h2 className="text-xl text-white mb-2">Access Denied</h2>
          <p className="text-sm">You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }
  return children;
}
